import classes from "./CircularSpinner.module.css";

const CircularSpinner = (props) => {
    return <span className={classes.loader}></span>
};

export default CircularSpinner;
